'use client';

import { c as _c } from "react/compiler-runtime";
import { Alert, AlertTitle, Button } from '@repo/ui/components';
import { TriangleAlert } from '@repo/ui/icons';
import type { ReactNode } from 'react';

/**
 * An inline warning that asks before a risky change, instead of a dialog. Its buttons sit under
 * the text, so a long sentence never runs under them in the narrow panel. Focus starts on Cancel.
 */
export const ConfirmWarning = t0 => {
  const $ = _c(17);
  const {
    children,
    confirmLabel,
    confirmVariant: t1,
    disabled: t2,
    onCancel,
    onConfirm
  } = t0;
  const confirmVariant = t1 === undefined ? "default" : t1;
  const disabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TriangleAlert data-sentry-element="TriangleAlert" data-sentry-source-file="confirm-warning.tsx" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== children) {
    t4 = <AlertTitle className="leading-snug" data-sentry-element="AlertTitle" data-sentry-source-file="confirm-warning.tsx">{children}</AlertTitle>;
    $[1] = children;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== disabled || $[4] !== onCancel) {
    t5 = <Button autoFocus={true} disabled={disabled} onClick={onCancel} size="sm" variant="ghost" data-sentry-element="Button" data-sentry-source-file="confirm-warning.tsx">Cancel</Button>;
    $[3] = disabled;
    $[4] = onCancel;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== confirmLabel || $[7] !== confirmVariant || $[8] !== disabled || $[9] !== onConfirm) {
    t6 = <Button disabled={disabled} onClick={onConfirm} size="sm" variant={confirmVariant} data-sentry-element="Button" data-sentry-source-file="confirm-warning.tsx">{confirmLabel}</Button>;
    $[6] = confirmLabel;
    $[7] = confirmVariant;
    $[8] = disabled;
    $[9] = onConfirm;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="col-start-2 mt-2 flex justify-end gap-1">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <Alert className="transition-[opacity,translate] duration-150 ease-drawer starting:translate-y-1 starting:opacity-0 motion-reduce:starting:translate-y-0" variant="warning" data-sentry-element="Alert" data-sentry-component="ConfirmWarning" data-sentry-source-file="confirm-warning.tsx">{t3}{t4}{t7}</Alert>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};